const header = document.getElementById('Header');
const allSections = document.querySelectorAll('[data-header-skin]');
let firstSection = null;
if (allSections.length > 0) {
  firstSection = allSections[0];
}

window.addEventListener('scroll', () => {
  const stickyBackgroundColor = header.dataset.stickyBackgroundColor;
  const stickyBackgroundColorMobile = header.dataset.stickyBackgroundColorMobile;
  const backgroundColor = header.dataset.backgroundColor;

  const isMobile = window.matchMedia('(max-width: 749px)');

  if (window.scrollY > 10) {
    header.classList.remove(backgroundColor);
    header.classList.add(stickyBackgroundColor, stickyBackgroundColorMobile);
    if (isMobile.matches) {
      switchHeader('#4E493C', 'secondImage');
      header.setAttribute('data-skin', 'dark');
    }
  } else {
    header.classList.remove(stickyBackgroundColor, stickyBackgroundColorMobile);
    header.classList.add(backgroundColor);
    if (isMobile.matches) {
      switchHeader('#4E493C', 'firstImage');
      header.setAttribute('data-skin', firstSection ? firstSection.dataset.headerSkin : 'dark');
    }
  }

  header.querySelectorAll('.hide-on-scroll').forEach((el) => {
    if (window.scrollY > 10) {
      el.classList.add('hidden!');
    } else {
      el.classList.remove('hidden!');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  if (header.dataset.secondColor == 'true') {
    switchHeader('#4E493C', 'secondImage');
  }
});

function switchHeader(color, newImagedataSet) {
  header
    .querySelectorAll(
      `
        h1,h2,h3,h4,h5,h6,
        p,li,dt,dd,blockquote,small,
        a,span:not(.cart-count-bubble *),label,figcaption,th,td,.icon.icon-hamburger
      `
    )
    .forEach((el) => (el.style.color = color));

  header.querySelectorAll('img').forEach((img) => {
    const secondImage = img.parentElement?.dataset[newImagedataSet];
    if (secondImage && secondImage != '') {
      const newImage = document.createElement('img');
      newImage.src = secondImage.startsWith('//') ? `https:${secondImage}` : secondImage;
      if (img.src === newImage.src) return;
      newImage.alt = img.alt || '';
      newImage.className = img.className;
      newImage.width = img.width;
      newImage.height = img.height;
      newImage.loading = img.loading || 'lazy';
      img.replaceWith(newImage);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.shopify-section-group-header-group #Header');
  if (!header) return;

  function updateHeaderHeight() {
    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
});
